import React, { useState } from "react";
import MainLayout from "../../components/Layouts/Main/MainLayout.index";
import FW from "../../config/word.json";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  MenuContainer,
  MenuCategory,
  MenuCategoryTitle,
  SubMenuList,
  SubMenuLink,
  CategoryIcon,
} from "./Menu.style";

export default function Menu() {
  const navigate = useNavigate();
  const [openCategory, setOpenCategory] = useState(null);

  useEffect(() => {
    const userId = sessionStorage.getItem("userId");
    if (!userId) {
      navigate("/");
      return;
    }
  }, [navigate]);

  const menuCategories = [
    {
      id: "approval",
      title: "承認フロー",
      icon: "📋",
      items: [
        { title: FW.F_W_HOME_ApprovalList, path: "/approvallist" },
        { title: FW.F_W_HOME_ApprovaledList, path: "/approvaledlist" },
        { title: FW.F_W_HOME_RejectList, path: "/rejectedlist" },
      ],
    },
    {
      id: "banner",
      title: "バナー管理",
      icon: "🖼️",
      items: [
        { title: "大バナー", path: "/bannerManage" },
        { title: "小バナー", path: "/smallBannerManage" },
      ],
    },
  ];

  const toggleCategory = (categoryId) => {
    setOpenCategory(openCategory === categoryId ? null : categoryId);
  };

  return (
    <MainLayout>
      <MenuContainer>
        {menuCategories.map((category) => (
          <MenuCategory key={category.id}>
            <MenuCategoryTitle
              onClick={() => toggleCategory(category.id)}
              className={openCategory === category.id ? "open" : ""}
            >
              <CategoryIcon>{category.icon}</CategoryIcon>
              {category.title}
              <span className="toggle">
                {openCategory === category.id ? "−" : "+"}
              </span>
            </MenuCategoryTitle>
            {openCategory === category.id && (
              <SubMenuList>
                {category.items.map((item, index) => (
                  <SubMenuLink to={item.path} key={index}>
                    {item.title}
                  </SubMenuLink>
                ))}
              </SubMenuList>
            )}
          </MenuCategory>
        ))}
      </MenuContainer>
    </MainLayout>
  );
}
